import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import saveAs from 'file-saver';
import JSZip from 'jszip';
import _ from 'lodash';
import { Table, TableHeaderCheckbox } from 'primeng/table';
import {
  ProgramTypesGUID,
  Milestone2PaymentBatchStatus,
  EventsPaymentScheduleTab
} from '../../../models/_enum-collections';
import { ApiResponse } from '../../../models/api-response.model';
import {
  EventMilestone2PaymentBatchEvents,
  EventMilestone2PaymentBatchExport,
  EventMilestone2PaymentBatch,
  EventMilestone2PaymentBatchSchedule
} from '../../../models/event-milestone2-payment-batch-events.model';
import {
  EventMilestone2PaymentBatchExportZip,
  DynamicProperties,
  milestone2PaymentBatchExportZip
} from '../../../models/event-milestone2-payment-batch-export';
import { EventPaymentBatchStatusDropDown } from '../../../models/event-payment-batch-status.model';
import { AppConstants } from '../../common/app-constants';
import { CommonService } from '../../common/common.service';
import { EventPaymentScheduleService } from '../../services/event-payment-schedule.service';
import { ExportService } from '../../services/export.service';
import { CommonSharedModule } from '../../common/shared.module';
import eventNewPaymentBatchMilestone2Config from './event-edit-payment-batch-milestone2-config.json';

@Component({
  selector: 'app-event-edit-payment-batch-milestone2',
  templateUrl: './event-edit-payment-batch-milestone2.component.html',
  styleUrls: ['./event-edit-payment-batch-milestone2.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class EventEditPaymentBatchMilestone2Component implements OnInit {
  @ViewChild('dt', { static: false }) dt!: Table;
  @ViewChild('headerCheckbox', { static: false })
  headerCheckbox!: TableHeaderCheckbox;
  pbName!: string;
  msgs: any[] = [];
  apires!: ApiResponse;
  editPaymentBatchForm!: FormGroup;
  engcols!: any[];
  eventMilestone2PaymentScheduleId!: number;
  eventMilestone2PaymentBatchStatusId!: number;
  paymentBatchEvents: EventMilestone2PaymentBatchEvents[] = [];
  copyOfpaymentBatchEvents!: EventMilestone2PaymentBatchEvents[];
  selectedEvents!: EventMilestone2PaymentBatchEvents[];
  paymentBatchEngagementExport: EventMilestone2PaymentBatchExport[] = [];
  selectedEventsExport!: EventMilestone2PaymentBatchEvents[];
  copyAssociatedEvents!: EventMilestone2PaymentBatchEvents[];
  paymentBatchStatus: EventPaymentBatchStatusDropDown[] = [];
  updatePaymentBatch!: EventMilestone2PaymentBatch;
  datePipe = new DatePipe('en-US');
  dataViewRecsPerPage!: number;
  tblPageNumber!: number;
  currentPageInfo!: string;
  totalRecords!: number;
  pageLinksPerPage!: number;
  engagementId!: string;
  engagementName!: string;
  payoutMetric!: string;
  showForm = true;
  isShowOnlyAssoctd = true;
  loading = false;
  isSpin = false;
  isSpinEx = false;
  loadingIcon = 'fa-circle-o-notch';
  isBatchEventsDeletedConfirmation = false;
  warningMessage =
    'Event Keys will be removed from the batch. Do you wish to continue?';
  programTypeGuid: string = ProgramTypesGUID.Events;
  isMRPP = false;

  constructor(
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private eventPaymentScheduleService: EventPaymentScheduleService,
    private exportService: ExportService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.pbName = this.route.snapshot.paramMap.get('pbName') || '';
    this.dataViewRecsPerPage = 15;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.isMRPP =
      this.getProgramTypeGuid() == ProgramTypesGUID.MRPP ? true : false;
    this.getEventSheduleHeaderFilelds();
    this.engcols = [
      { field: 'eventKey', header: 'Event Key' },
      { field: 'eventRegistrationId', header: 'Event ID' },
      { field: 'programType', header: 'Program Type' },
      { field: 'eventName', header: 'Event Name' },
      { field: 'partnerName', header: 'Partner Name' },
      { field: 'customerTenantId', header: 'Customer TenantID' },
      { field: 'payoutMetric', header: 'Payment Type' },
      { field: 'tier', header: 'Milestone 2 Tier' },
      { field: 'maturityStatus', header: 'Maturity Status' },
      { field: 'maturityDate', header: 'Maturity Date' },
      { field: 'fundingAmount', header: 'Funding Amount' },
      { field: 'partnerLocation', header: 'Partner Location' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'profileStatus', header: 'ProfileStatus' },
      { field: 'partnerPriority', header: 'Partner Priority' },
      { field: 'blockedStatus', header: 'Blocked Status' },
      { field: 'partnerId', header: 'Partner ID' },
      { field: 'payeeName', header: 'Payee Name' },
      { field: 'contactName', header: 'Contact Name' },
      { field: 'contactEmail', header: 'Contact Email' },
      { field: 'emailLanguage', header: 'Email Language' },
      { field: 'accountCode', header: 'Account Code' },
      {
        field: 'internalOrderOrCostCenter',
        header: 'Internal Code or Cost Center'
      },
      { field: 'currency', header: 'Currency' },
      { field: 'amount', header: 'Amount' },
      { field: 'netAmount', header: 'Net Amount' },
      { field: 'taxAmount', header: 'Tax Amount' },
      { field: 'msInvoiceNumber', header: 'MS Invoice Number' },
      { field: 'msInvoicePaidDate', header: 'MS Invoice Paid Date' },
      {
        field: 'paymentCentralTransactionId',
        header: 'Payment Central Transaction ID'
      },
      { field: 'paymentDocumentNumber', header: 'Payment Document Number' }
    ];

    this.getPaymentBatchStatus();

    this.editPaymentBatchForm = this.formBuilder.group({
      paymentBatchName: [''],
      paymentBatchScheduleDate: ['', [Validators.required]],
      anticipatedPaymentDate: ['', [Validators.required]],
      actualPaymentCentralDate: [''],
      paymentBatchStatus: ['', [Validators.required]],
      selectedEvnts: [''],
      amount: [''],
      partnerId: [''],
      payeeName: [''],
      contactName: [''],
      contactEmail: [''],
      emailLanguage: [''],
      accountCode: [''],
      internalOrderOrCostCenter: [''],
      currency: [''],
      netAmount: [''],
      taxAmount: [''],
      msInvoiceNumber: [''],
      msInvoicePaidDate: [''],
      paymentCentralTransactionId: [''],
      paymentCentralRequestId: [''],
      programType: ['']
    });

    this.getPaymentBatchDetails(this.pbName);
  }

  getPaymentBatchStatus() {
    this.eventPaymentScheduleService
      .getPaymentBatchStatus()
      .subscribe(engList => {
        this.paymentBatchStatus = engList;
      });
  }

  getPaymentBatchDetails(pbName: string): void {
    const programTypeGuid =
      this.getProgramTypeGuid() == ProgramTypesGUID.MRPP
        ? ProgramTypesGUID.MRPP
        : ProgramTypesGUID.Events;
    this.eventPaymentScheduleService
      .getMilestone2PaymentBatchEventDetails(pbName, programTypeGuid)
      .subscribe(paymentBatchDetails => {
        if (!paymentBatchDetails.paymentScheduleBatch) {
          this.loading = false;
          return;
        }
        this.pbName = pbName;
        this.eventMilestone2PaymentScheduleId =
          paymentBatchDetails.paymentScheduleBatch
            .eventMilestone2PaymentScheduleId || -1;
        this.eventMilestone2PaymentBatchStatusId =
          paymentBatchDetails.paymentScheduleBatch.paymentBatchStatusId || -1;
        this.editPaymentBatchForm.controls['paymentBatchStatus'].setValue({
          eventPaymentBatchStatusId:
            paymentBatchDetails.paymentScheduleBatch.paymentBatchStatusId,
          eventPaymentBatchStatus:
            paymentBatchDetails.paymentScheduleBatch.paymentBatchStatus
        });

        const datePipe = new DatePipe('en-US');
        const epaymentBatchScheduleDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch.paymentBatchScheduleDate,
          'MM/dd/yyyy'
        );
        const eanticipatedPaymentDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch.anticipatedPaymentDate,
          'MM/dd/yyyy'
        );
        const eactualPaymentCentralDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch.actualPaymentCentralDate,
          'MM/dd/yyyy'
        );

        this.editPaymentBatchForm.patchValue({
          paymentBatchName:
            paymentBatchDetails.paymentScheduleBatch.paymentBatchName,
          paymentBatchScheduleDate: epaymentBatchScheduleDate,
          anticipatedPaymentDate: eanticipatedPaymentDate,
          actualPaymentCentralDate: eactualPaymentCentralDate,
          paymentCentralRequestId:
            paymentBatchDetails.paymentScheduleBatch.paymentCentralRequestId
        });

        this.paymentBatchEvents = paymentBatchDetails.batchEvents || [];
        this.copyOfpaymentBatchEvents = this.paymentBatchEvents;
        this.paymentBatchEvents = this.paymentBatchEvents
          .map(e => {
            return { ...e, editCheckBox: false };
          })
          .filter(e => e.associated === 1);
        this.selectedEvents = this.paymentBatchEvents.filter(
          x => x.associated === 1
        );
        this.copyAssociatedEvents = this.paymentBatchEvents.filter(
          e => e.associated === 1
        );

        this.onAddNewEvents(true);
        this.loading = false;
      });
  }

  onAddNewEvents(isAssociated: boolean) {
    this.isShowOnlyAssoctd = isAssociated;
    if (this.isShowOnlyAssoctd) {
      if (this.dt) {
        this.dt.filter(1, 'associated', 'equals');
      }

      this.totalRecords = this.paymentBatchEvents.filter(
        x => x.associated
      ).length;

      if (this.totalRecords === 0) {
        this.currentPageInfo = 'No Record Found';
      }
      if (
        this.totalRecords > 0 &&
        this.totalRecords > this.dataViewRecsPerPage
      ) {
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.dataViewRecsPerPage +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
      if (
        this.totalRecords > 0 &&
        this.totalRecords <= this.dataViewRecsPerPage
      ) {
        this.currentPageInfo =
          'Showing 1 - ' +
          this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
    } else {
      if (this.dt) {
        this.dt.reset();
      }

      const uniqEventIds = new Set(
        this.paymentBatchEvents.map(d => d.eventKey)
      );
      this.paymentBatchEvents = [
        ...this.paymentBatchEvents,
        ...this.copyOfpaymentBatchEvents.filter(
          d => !uniqEventIds.has(d.eventKey)
        )
      ];

      this.totalRecords = this.copyOfpaymentBatchEvents.length;

      if (this.totalRecords === 0) {
        this.currentPageInfo = 'No Record Found';
      }
      if (
        this.totalRecords > 0 &&
        this.totalRecords > this.dataViewRecsPerPage
      ) {
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.dataViewRecsPerPage +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
      if (
        this.totalRecords > 0 &&
        this.totalRecords <= this.dataViewRecsPerPage
      ) {
        this.currentPageInfo =
          'Showing 1 - ' +
          this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
    }
  }

  onSubmit() {
    this.isBatchEventsDeletedConfirmation = false;
    if (
      this.selectedEvents.length === 0 &&
      this.editPaymentBatchForm.controls['paymentBatchStatus'].value
        .eventPaymentBatchStatusId !== Milestone2PaymentBatchStatus.Cancelled
    ) {
      this.loading = false;
      this.msgs = [];
      this.msgs.push({
        severity: 'error',
        detail: 'Please select any one Event from the list'
      });
      setTimeout(() => {
        this.msgs = [];
      }, 5000);
      return;
    }

    if (!this.isMRPP) {
      const initialEventKeys = this.copyAssociatedEvents.map(
        m => m.eventKey + '(' + m.tier + ')'
      );
      const currentEventKeys = this.selectedEvents.map(
        m => m.eventKey + '(' + m.tier + ')'
      );
      const eventKeysUnchecked = initialEventKeys.filter(
        item => !currentEventKeys.includes(item)
      );
      const removedEventKeys = [...new Set(eventKeysUnchecked)];
      if (
        removedEventKeys.length > 0 &&
        this.editPaymentBatchForm.controls['paymentBatchStatus'].value
          .eventPaymentBatchStatusId !== Milestone2PaymentBatchStatus.Cancelled
      ) {
        this.isBatchEventsDeletedConfirmation = true;
        this.warningMessage =
          (removedEventKeys.length === 1 ? 'Event Key' : 'Event Keys') +
          ': ' +
          removedEventKeys.join(', ') +
          ' will be removed from the batch. Do you wish to continue?';
      } else {
        this.updateMilestone2Batch();
      }
    } else {
      const initialEvents = this.copyAssociatedEvents.map(m => m.eventKey);
      const currentEvents = this.selectedEvents.map(m => m.eventKey);
      const eventsUnchecked = initialEvents.filter(
        item => !currentEvents.includes(item)
      );
      const removedEvents = [...new Set(eventsUnchecked)];

      if (
        removedEvents.length > 0 &&
        this.editPaymentBatchForm.controls['paymentBatchStatus'].value
          .eventPaymentBatchStatusId !== Milestone2PaymentBatchStatus.Cancelled
      ) {
        this.isBatchEventsDeletedConfirmation = true;
        this.warningMessage =
          (removedEvents.length === 1 ? 'Line Item Id' : 'Line Item Ids') +
          ': ' +
          removedEvents.join(', ') +
          ' will be removed from the batch. Do you wish to continue?';
      } else {
        this.updateMilestone2Batch();
      }
    }
  }

  onConfirm() {
    this.isBatchEventsDeletedConfirmation = false;
    this.updateMilestone2Batch();
  }

  onCancel() {
    this.isBatchEventsDeletedConfirmation = false;
    this.loading = false;
  }

  updateMilestone2Batch() {
    this.loading = true;
    const datePipe = new DatePipe('en-US');
    const ScheduleDate = datePipe.transform(
      this.editPaymentBatchForm.controls['paymentBatchScheduleDate'].value,
      'MM/dd/yyyy'
    );
    const anticipatedPaymentDate = datePipe.transform(
      this.editPaymentBatchForm.controls['anticipatedPaymentDate'].value,
      'MM/dd/yyyy'
    );
    const actualPaymentCentralDate = datePipe.transform(
      this.editPaymentBatchForm.controls['actualPaymentCentralDate'].value,
      'MM/dd/yyyy'
    );

    const batchDetails: EventMilestone2PaymentBatchSchedule = {
      paymentBatchScheduleDate: this.getDate(
        new Date(ScheduleDate || '')
      ).toISOString(),
      anticipatedPaymentDate: this.getDate(
        new Date(anticipatedPaymentDate || '')
      ).toISOString(),
      actualPaymentCentralDate:
        actualPaymentCentralDate
          ? this.getDate(new Date(actualPaymentCentralDate)).toISOString()
          : null,
      paymentBatchStatusId:
        this.editPaymentBatchForm.controls['paymentBatchStatus'].value
          .eventPaymentBatchStatusId,
      paymentBatchName:
        this.editPaymentBatchForm.controls['paymentBatchName'].value,
      paymentCentralRequestId:
        this.editPaymentBatchForm.controls['paymentCentralRequestId'].value,
      programTypeGuid: this.programTypeGuid
    };

    this.updatePaymentBatch = {
      batchEvents: []
    };

    if (
      batchDetails.paymentBatchStatusId ===
      Milestone2PaymentBatchStatus.Cancelled
    ) {
      this.selectedEvents = [];
    }
    this.updatePaymentBatch.batchEvents = [];

    if (
      this.selectedEvents.length !== 0 ||
      this.selectedEvents.length !== undefined ||
      batchDetails.paymentBatchStatusId ===
        Milestone2PaymentBatchStatus.Cancelled
    ) {
      this.selectedEvents.forEach(ele => {
        this.updatePaymentBatch.batchEvents?.push(ele);
      });
    }

    this.updatePaymentBatch.paymentScheduleBatch = batchDetails;

    this.eventPaymentScheduleService
      .updateEventMilestone2PaymentBatch(this.updatePaymentBatch)
      .subscribe(
        messageResponse => {
          this.loading = false;
          this.apires = messageResponse;
          this.setMessage('Payment Batch Updated Successfully', 'success');
          this.editPaymentBatchForm.reset();
          this.showForm = false;
          this.selectedEvents = [];
          setTimeout(() => {
            this.router.navigate(['events-payment-schedule'], {
              queryParams: { tab: EventsPaymentScheduleTab.Milestone2 },
              skipLocationChange: true
            });
          }, 2000);
        },
        error => {
          this.loading = false;
          let errors: string[] = [];
          const paymentRequestIDWarningMessage =
            'Payment Central RequestID is already exists.';
          if (error.status === 400) {
            errors = this.commonService.getBadRequestErrors(error);
            for (const msg of errors) {
              this.setMessage(msg, 'warn', true);
            }
          } else if (error.error === paymentRequestIDWarningMessage) {
            this.setMessage(paymentRequestIDWarningMessage, 'warn');
          } else {
            this.setMessage(
              'Sorry an Error Occurred while Creating Payment Batch',
              'warn'
            );
          }
        }
      );
  }

  setMessage(msg: any, severity: string, noReset?: boolean) {
    if (!noReset) {
      this.msgs = [];
    }
    this.msgs.push({ severity: severity || 'error', detail: msg });
  }

  pageChange(e: any) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }

    setTimeout(() => {
      if (this.headerCheckbox.checked) {
        if (
          this.selectedEvents &&
          this.selectedEvents.length != this.totalRecords
        ) {
          this.headerCheckbox.checked = false;
        }
      }
    }, 0);
  }

  applyFilter(event: any) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  reset() {
    if (this.isShowOnlyAssoctd) {
      if (
        this.paymentBatchEvents === null ||
        this.paymentBatchEvents.length === 0
      ) {
        this.totalRecords = 0;
        this.currentPageInfo = 'No Records Found';
      } else {
        if (this.dt) {
          this.dt.sortField = 'eventRegistrationId';
          this.dt.sortOrder = -1;
          this.dt.filter(1, 'associated', 'equals');
        }
        this.totalRecords = this.paymentBatchEvents.filter(
          x => x.associated
        ).length;

        if (this.totalRecords === 0) {
          this.currentPageInfo = 'No Record Found';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords > this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords <= this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            this.totalRecords +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
      }
    } else {
      if (this.dt) {
        this.dt.sortField = 'eventRegistrationId';
        this.dt.sortOrder = -1;
        this.dt.reset();
      }

      if (
        this.paymentBatchEvents === null ||
        this.paymentBatchEvents.length === 0
      ) {
        this.totalRecords = 0;
        this.currentPageInfo = 'No Records Found';
      } else {
        this.totalRecords = this.paymentBatchEvents.length;
        if (
          this.totalRecords > 0 &&
          this.totalRecords > this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords <= this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            this.totalRecords +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
      }
    }
  }

  cancelSearchNav() {
    this.router.navigate(['events-payment-schedule'], {
      queryParams: { tab: EventsPaymentScheduleTab.Milestone2 },
      skipLocationChange: true
    });
  }

  private getDate(date: Date): Date {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  }

  isPaidBatch() {
    return (
      this.eventMilestone2PaymentBatchStatusId ===
      Milestone2PaymentBatchStatus.Paid
    );
  }

  formatDate(dateString: string): string {
    const datePipe = new DatePipe('en-US');
    return datePipe.transform(dateString, 'MM/dd/yyyy') || '';
  }

  selectRow(e) {
    if (e === false) {
      setTimeout(() => {
        if (this.headerCheckbox.checked) this.headerCheckbox.checked = false;
      }, 0);
    } else if (e === true) {
      setTimeout(() => {
        if (this.headerCheckbox.checked) {
          if (
            this.selectedEvents &&
            this.selectedEvents.length != this.totalRecords
          ) {
            this.headerCheckbox.checked = false;
          }
        }
      }, 0);
    }
  }

  exportCSV() {
    this.paymentBatchEngagementExport = [];
    const orderOfItems = [
      'LineItemId',
      'TransactionId',
      'PayeeName',
      'PayeeID',
      'ContactName',
      'ContactEmail',
      'EmailLanguage',
      'AccountCode',
      'InternalOrderOrCostCenter',
      'Currency',
      'NetAmount',
      'TaxAmount',
      'PayoutMetric'
    ];
    this.selectedEvents.forEach(data => {
      const exportItem: EventMilestone2PaymentBatchExport = {
        TransactionId: data.eventRegistrationId?.toString(),
        PayeeName: data.payeeName,
        ContactName: data.contactName,
        ContactEmail: data.contactEmail,
        EmailLanguage: data.emailLanguage,
        AccountCode: data.accountCode,
        InternalOrderOrCostCenter: data.internalOrderOrCostCenter,
        Currency: data.currency,
        NetAmount: data.netAmount,
        TaxAmount: data.taxAmount
      };
      if (this.getProgramTypeGuid() == ProgramTypesGUID.MRPP) {
        exportItem.LineItemId = data.eventKey?.toString();
        exportItem.PayoutMetric = data.payoutMetric;
      }
      if (!this.isHidden('payeeID') && data.payeeID) {
        exportItem.PayeeID = parseInt(data.payeeID, 10);
      }
      this.paymentBatchEngagementExport.push(_.pick(exportItem, orderOfItems));
    });

    this.exportService.exportToCsv(
      this.paymentBatchEngagementExport,
      this.pbName + '.csv'
    );
  }

  async downloadExportZip() {
    this.isSpinEx = true;
    const selectedID = this.copyAssociatedEvents.map(event => ({
      EventID: event.eventRegistrationId,
      PartnerName: event.partnerName
    }));

    this.downloadExportPoeDocuments();
    await this.eventPaymentScheduleService
      .downloadExportPoeCSV(selectedID)
      .subscribe(downloadFile => {
        this.downloadEventsMilestone2Zip(downloadFile).then(
          () => (this.isSpinEx = false)
        );
      });
  }

  downloadExportPoeDocuments() {
    this.isSpinEx = true;
    const selectedID = this.copyAssociatedEvents.map(event => ({
      EventID: event.eventRegistrationId,
      PartnerName: event.partnerName
    }));
    this.eventPaymentScheduleService
      .downloadExportPoeDocuments(selectedID)
      .subscribe(downloadFile => {
        this.isSpinEx = false;
        const file = new Blob([downloadFile], {
          type: 'application/octet-stream'
        });
        saveAs(
          file,
          this.editPaymentBatchForm.controls['paymentBatchName'].value +
            '-POE_files.zip'
        );
      });
  }

  getEvetsDetailsExportJson(): EventMilestone2PaymentBatchExportZip[] {
    const eventdetailsExcelBuffer: any[] = [];
    const eventsByEventKey = this.copyAssociatedEvents.reduce(
      (
        accumulator: Record<number, EventMilestone2PaymentBatchEvents[]>,
        currentValue
      ) => {
        const eventKey = currentValue.eventKey as number;
        if (!accumulator[eventKey]) {
          accumulator[eventKey] = [];
        }
        accumulator[eventKey].push(currentValue);
        return accumulator;
      },
      {}
    );

    const groupbyEventKey: EventMilestone2PaymentBatchEvents[][] =
      Object.values(eventsByEventKey);
    groupbyEventKey.forEach(group => {
      const temp: EventMilestone2PaymentBatchExportZip = {
        LineItemId: '',
        EventRegistrationID: '',
        EventName: '',
        CountryName: '',
        CustomerName: '',
        PartnerName: '',
        PartnerID: '',
        RequestDate: '',
        FiscalYear: '',
        DateSubmittedPST: '',
        EventStatus: '',
        PartnerOneID: '',
        PartnerLocation: '',
        PayeeID: '',
        WorkshopCompletionDate: '',
        POECompletionDate: '',
        EventCompletionDate: '',
        PaymentType: '',
        Tier1PaymentAmount: '',
        Tier1MetDate: '',
        Tier1PaidDate: '',
        Tier1MaturityDate: '',
        Tier1MaturityStatus: '',
        Tier1Target: '',
        Tier1MSInvoiceNumber: '',
        Tier1MSInvoiceDate: '',
        Tier1PaymentCentralTransactionID: '',
        Tier1PaymentDocumentNumber: '',
        Tier2PaymentAmount: '',
        Tier2MetDate: '',
        Tier2PaidDate: '',
        Tier2MaturityDate: '',
        Tier2MaturityStatus: '',
        Tier2Target: '',
        Tier2MSInvoiceNumber: '',
        Tier2MSInvoiceDate: '',
        Tier2PaymentCentralTransactionID: '',
        Tier2PaymentDocumentNumber: '',
        CompletionDate: new Date(),
        PaymentAmount: '',
        EvaluatedMonth: '',
        NetIncrementMAD: '',
        NetIncrementLicenses: '',
        MaturityDate: '',
        MaturityStatus: '',
        Target: ''
      };

      if (!this.isMRPP) {
        const eventTire1 = group.find(item => item.tier == 'Tier 1');
        const eventTire2 = group.find(item => item.tier == 'Tier 2');
        const event = eventTire1
          ? eventTire1
          : eventTire2
            ? eventTire2
            : undefined;
        if (event) {
          temp.EventRegistrationID =
            event.eventRegistrationId?.toString() || '';
          temp.EventName = event.eventName || '';
          temp.CountryName = event.customerCountry;
          temp.CustomerName = event.customerName || '';
          temp.PartnerName = event.partnerName || '';
          temp.PartnerID = event.partnerId || '';
          temp.RequestDate = event.requestDate || '';
          temp.FiscalYear = event.fiscalYear || '';
          temp.DateSubmittedPST = event.dateSubmittedPST || '';
          temp.EventStatus = event.engagementStatus;
          temp.PartnerOneID = event.partnerOneID || '';
          temp.PartnerLocation = event.partnerLocation || '';
          temp.PayeeID = event.payeeID || '';
          temp.WorkshopCompletionDate =
            this.datePipe.transform(event.completionDate, 'yyyy-MM-dd') || '';
          temp.POECompletionDate =
            this.datePipe.transform(event.poeCompletionDate, 'yyyy-MM-dd') ||
            '';
          temp.EventCompletionDate =
            this.datePipe.transform(event.completionDate, 'yyyy-MM-dd') || '';
          temp.PaymentType = event.payoutMetric?.split(' ')[1] || '';
        }
        if (eventTire1) {
          temp.Tier1PaymentAmount = eventTire1.fundingAmount || '';
          temp.Tier1MetDate =
            this.datePipe.transform(event?.tierMetDate, 'yyyy-MM-dd') || '';
          temp.Tier1PaidDate =
            this.datePipe.transform(
              eventTire1.msInvoicePaidDate,
              'yyyy-MM-dd'
            ) || '';
          temp.Tier1MaturityDate =
            this.datePipe.transform(eventTire1.maturityDate, 'yyyy-MM-dd') ||
            '';
          temp.Tier1MaturityStatus = eventTire1.maturityStatus || '';
          temp.Tier1Target = eventTire1.tierTarget || '';
          temp.Tier1MSInvoiceNumber = eventTire1.msInvoiceNumber || '';
          temp.Tier1MSInvoiceDate =
            this.datePipe.transform(
              eventTire1.msInvoicePaidDate,
              'yyyy-MM-dd'
            ) || '';
          temp.Tier1PaymentCentralTransactionID =
            eventTire1.paymentCentralTransactionId || '';
          temp.Tier1PaymentDocumentNumber =
            eventTire1.paymentDocumentNumber || '';
        }
        if (eventTire2) {
          temp.Tier2PaymentAmount = eventTire2.fundingAmount || '';
          temp.Tier2MetDate = event?.tierMetDate || '';
          temp.Tier2PaidDate =
            this.datePipe.transform(
              eventTire2.msInvoicePaidDate,
              'yyyy-MM-dd'
            ) || '';
          temp.Tier2MaturityDate =
            this.datePipe.transform(eventTire2.maturityDate, 'yyyy-MM-dd') ||
            '';
          temp.Tier2MaturityStatus = eventTire2.maturityStatus || '';
          temp.Tier2Target = eventTire2.tierTarget || '';
          temp.Tier2MSInvoiceNumber = eventTire2.msInvoiceNumber || '';
          temp.Tier2MSInvoiceDate =
            this.datePipe.transform(
              eventTire2.msInvoicePaidDate,
              'yyyy-MM-dd'
            ) || '';
          temp.Tier2PaymentCentralTransactionID =
            eventTire2.paymentCentralTransactionId || '';
          temp.Tier2PaymentDocumentNumber =
            eventTire2.paymentDocumentNumber || '';
        }

        eventdetailsExcelBuffer.push(temp);
      } else {
        this.programTypeGuid = this.getProgramTypeGuid();
        const programTypeConfig =
          eventNewPaymentBatchMilestone2Config.program.find(
            obj => obj.programTypeGuid === this.programTypeGuid
          );
        const dynamicProperties: DynamicProperties = {};
        programTypeConfig?.zipExcelfileNameHeaders.forEach(header => {
          const dataKey = header.name;
          if (dataKey.endsWith('Date')) {
            dynamicProperties[header.displayName] =
              this.datePipe.transform(group[0][dataKey], 'yyyy-MM-dd') || '';
          } else {
            dynamicProperties[header.displayName] = group[0][dataKey];
          }
        });
        const temp = new milestone2PaymentBatchExportZip(dynamicProperties);
        eventdetailsExcelBuffer.push(temp);
      }
    });
    return eventdetailsExcelBuffer;
  }

  async downloadEventsMilestone2Zip(csvBinary): Promise<boolean> {
    const zip = new JSZip();
    this.programTypeGuid = this.getProgramTypeGuid();
    const programTypeConfig = eventNewPaymentBatchMilestone2Config.program.find(
      obj => obj.programTypeGuid === this.programTypeGuid
    );

    const zipFolderName = programTypeConfig?.zipFolderName;
    const firstFolder = zip.folder(this.pbName + '-' + zipFolderName);
    const evetsDetailsExportJson = this.getEvetsDetailsExportJson();
    const EventdetailsExcelBuffer =
      this.exportService.createExcelBufferFromJson(evetsDetailsExportJson);
    const excelFilename = programTypeConfig?.zipExcelfileName;

    if (firstFolder) {
      firstFolder.file(
        this.pbName + '-' + excelFilename,
        EventdetailsExcelBuffer
      );
    }

    const file = new Blob([csvBinary], { type: 'application/octet-stream' });
    zip.file(this.pbName + '-Survey.zip', file, { binary: true });

    const zipFileContents = await zip.generateAsync({ type: 'uint8array' });
    const blob = new Blob([zipFileContents as BlobPart], { type: 'application/zip' });

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.isMRPP
      ? saveAs(blob, this.pbName + '-Engagement_Info')
      : saveAs(blob, this.pbName + '.zip');
    return true;
  }

  getEventSheduleHeaderFilelds() {
    this.programTypeGuid = this.getProgramTypeGuid();
    const programTypeConfig = eventNewPaymentBatchMilestone2Config.program.find(
      obj => obj.programTypeGuid === this.programTypeGuid
    );
    this.engagementId =
      programTypeConfig?.element.find(
        obj => obj.id === 'engagementRegistrationId'
      )?.displayName || '';
    this.engagementName =
      programTypeConfig?.element.find(obj => obj.id === 'engagementName')
        ?.displayName || '';
    this.payoutMetric =
      programTypeConfig?.element.find(obj => obj.id === 'payoutMetric')
        ?.displayName || '';
  }

  isHidden(element: string) {
    this.programTypeGuid = this.getProgramTypeGuid();
    const programTypeConfig = eventNewPaymentBatchMilestone2Config.program.find(
      obj => obj.programTypeGuid === this.programTypeGuid
    );
    if (programTypeConfig?.hiddenElements.find(obj => obj.name == element)) {
      return true;
    } else {
      return false;
    }
  }

  getProgramTypeGuid() {
    if (history.state.programTypeGuid) return history.state.programTypeGuid;
    else if (localStorage.getItem('programTypeGuid')) {
      const guid = localStorage.getItem('programTypeGuid');
      return guid as ProgramTypesGUID;
    } else return ProgramTypesGUID.Events;
  }
}
